<h1 mat-dialog-title>
    {{ data.fileSizeProhibited ? 'Printed File Exceeds 100 MB' : 'Printed File Exceeds 25 MB' }}
</h1>
<div mat-dialog-content>
    <p>
        {{
            data.fileSizeProhibited
                ? 'Please print a file lower than 100MB. Please Skip or Cancel to continue. If the issue persist please contact support.'
                : 'The printed document exceeds 25 MB. You may save the printed document as is. You can not add signatures or apply F and I form data. If the issue persist please contact support.'
        }}
    </p>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">OK</button>
</div>
